import styled from '@emotion/styled';
import { Accordion } from '@zapier/design-system';
import { RichText } from 'components/RichText/RichText';
import React from 'react';

interface Props {
  title: string | null;
  openByDefault: boolean;
  content: any;
}

export const CollapsibleArea = (props: Props) => {
  const { title, content, openByDefault } = props;

  return (
    <Outer>
      <Accordion title={title} isInitiallyOpen={openByDefault}>
        <RichText body={content} persona={null} />
      </Accordion>
    </Outer>
  );
};

const Outer = styled.div`
  margin: 20px 0;
`;
